import React from "react";
import {Row, Col} from "react-bootstrap";
import ReactLoading from 'react-loading';
import Component from "./components/AscComponent";
import {withRouter} from "react-router-dom";
import Routes from "./AscRoutes";
import Header from "./containers/Elements/Header/Header";
import "./App.css";
import Gitversion from './GitVersion.json';
import loginImg from "./image/signin-bg.jpg";
import loginImgRecstar from "./image/rec-star-signin-bg.jpg";
import * as GlobalConst from "./components/AscConstants";
import {
    applyThemeColors,
    getThemeParameterType,
    hasThemeParameters,
    readCachedSystemParameters,
    applyDocumentTitle,
    writeCachedSystemParameters,
} from "./themeBootstrap";

// 【#384】require の引数を変数にすると webpack が解決対象を静的に特定できず
// 「Critical dependency: the request of a dependency is an expression」警告になる。
// テンプレートリテラルを require へ直接渡すことで、接頭・接尾が固定された
// 解決対象（./lang/*/Elements/*）として webpack に認識させる。
// 未翻訳の言語は例外になるため、従来どおり捕捉して null を返す。
const tryRequireLangElement = (lang, row) => {
    try {
        return require(`./lang/${lang}/Elements/${row}`);
    } catch (e) {
        return null;
    }
};

class App extends Component {
    constructor(props) {
        super(props);
        const cachedSystemParameters = readCachedSystemParameters();

        this.state = {
            lang: "ja",
            isAuthenticated: false,
            isAuthenticating: true,
            isThemeReady: hasThemeParameters(cachedSystemParameters),
            headerHeight: GlobalConst.VALUES.header_height,
            width: window.innerWidth,
            appHeight: window.innerWidth < 768 ? "100%" : window.innerHeight - GlobalConst.VALUES.header_height,
            tableHeight: window.innerHeight - GlobalConst.VALUES.header_height - GlobalConst.VALUES.table_size_tune,
            userInfo: {},
            systemParameters: cachedSystemParameters,
        }
    }

    
    /**
     * システムパラメータ情報取得
     * @param param
     * @returns {json}
     */
    getSystemParameterByType = async(background = false) => {
        let url_parm = getThemeParameterType();
        let res;

        try {
            res = await this.ascAxios('post', `Sign/getSystemParameterByType`, {parameter_type: url_parm});
        } catch (err) {
            // システムパラメータ取得不可時のみ、App.css の既定テーマで継続する。
            console.error('システムパラメータを取得できないため、テーマ上書きは適用せず既定テーマを使用します。', err);
            if (!background) {
                this.setState({isThemeReady: true});
            }
            return;
        }

        applyThemeColors(res.data);
        // 【#524】タブのタイトルは DB の SYSTEMTITLE を正とする。
        // index.html のドメイン別分岐は React 起動前の初期表示用の控えとして残し、
        // 応答が来た時点でこちらが上書きする。DB を 1 行変えればタブも追随する。
        applyDocumentTitle(res.data);
        writeCachedSystemParameters(res.data, url_parm);
        this.setState({
            systemParameters: res.data,
            isThemeReady: true,
        });
    }

    getMyPath = () => {
        return this.props.location.pathname;
    }

    userHasAuthenticated = (authenticated, userInfo) => {
        let isAuthenticated = authenticated;
        userInfo = userInfo || {};

        this.setState({
            isAuthenticated,
            userInfo
        });
    };

    authenticating = authenticating => {
        this.setState({isAuthenticating: authenticating});
    };

    historyPush = (target) => {
        this.props.history.push(target);
    };

    async componentDidMount() {
        const themePromise = this.state.isThemeReady
            ? this.getSystemParameterByType(true)
            : this.getSystemParameterByType();

        try {
            let response = await this.ascAxios("post", "/Sign/check");
            if (response && response.data && response.data.user_id) {
                this.userHasAuthenticated(true, response.data);
            } else {
                this.historyPush("/SignIn");
            }
        } catch (e) {
            console.error(e);
        }

        // ウィンドウリサイズイベントリスナーを追加
        window.addEventListener('resize', this.handleResize);
        await themePromise.catch((err) => {
            console.error('テーマ適用エラー:', err);
        });
        this.authenticating(false);
    }

    componentWillUnmount() {
        // リサイズイベントリスナーを削除
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({
            width: window.innerWidth,
            appHeight: window.innerWidth < 768
                ? "100%"
                : window.innerHeight - GlobalConst.VALUES.header_height,
            tableHeight: window.innerHeight - GlobalConst.VALUES.header_height - GlobalConst.VALUES.table_size_tune
        });
    };

    getMyLangText = (lang) => {
        let langArr = [
            "Body",
            "Message",
            "Header",
            "SelectOption",
            "Table",
            "Time",
            "Value"
        ];

        let langObj = {};

        langArr.forEach(row => {
            // 同じ require を2回評価していたため、結果を変数に受けてから判定する
            const langElement = tryRequireLangElement(lang, row);
            langObj[row] = langElement ? langElement.default : require(`./lang/ja/Elements/${row}`).default;
        });

        return langObj;
    }
    getCharaLimit = () => {
        let limitObj = [];
        limitObj = require(`./chara_limit`).default;
        return limitObj;
    }

    getCurrentPermission = () => {
        let path = this.props.location.pathname.split("/")[1];

        if (this.state.userInfo.permission_data) {
            for(let feature of Object.keys(this.state.userInfo.permission_data)){
                if (feature.toLowerCase() === path.toLowerCase()) {
                    return this.state.userInfo.permission_data[feature];
                }
            }
        }

        // 【#475】機能を追加して CONTROLLER_LIST にキーを足しても、既存の権限プロファイル
        // （hm73_permissions.data）にはそのキーが補完されない。キーが無いと従来は {} を返しており、
        // 画面によって「入れない」「入れるが update 前提の表示が崩れる」に分かれていた。
        // CONTROLLER_LIST にあるキーについては、権限を持たない状態を明示した既定値を返す。
        // 既存レコードへのキー補完は docs/data-request-hm73-permissions-controller-keys.md を参照。
        const controller = GlobalConst.CONTROLLER_LIST
            .find(row => row.toLowerCase() === (path || "").toLowerCase());
        if (controller) {
            return {...GlobalConst.DEFAULT_PERMISSION};
        }

        return {};
    }

    render() {
        let childProps = {
            currentPermission: this.getCurrentPermission(),
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            historyPush: this.historyPush,
            lang: this.state.lang,
            width: this.state.width,
            userInfo: this.state.userInfo,
            getMyPath: this.getMyPath,
            langText: this.getMyLangText(this.state.lang),
            charaLimit: this.getCharaLimit(),
            tableHeight: this.state.tableHeight,
            boardWidth: {
                xxxsmall: 50,
                xxsmall: 60,
                xsmall: 80,
                small: 100,
                smedium: 120,
                medium: 140,
                large: 160,
                xlarge: 180,
                Control: 140,
                Date: 100,
                CallNumber: 120,
                Name: 120,
            },
            systemParameters: this.state.systemParameters
        };

        const isRecstar = window.location.host.includes("rec-star.com");
        const currentLoginImg = isRecstar ? loginImgRecstar : loginImg;
        let style = isRecstar
            ? {
                backgroundImage: `url(${currentLoginImg})`,
                backgroundSize: "contain",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#000",
            }
            : {
                backgroundImage: window.innerWidth < 768 ? `url(${currentLoginImg})`: `url(${currentLoginImg})`,
            };
        let appContent = <>
        <div className="signin-container">
                <Col xs={12} sm={12} className="signIn-logo-overview" style={style}>
                    
                    <Routes childProps={childProps}/>
                </Col>
                <div className="git-version">
                    {Gitversion.date}<br/>
                    Ver.{Gitversion.version}
                </div>
            </div>
        </>


        let permissionList = this.state.userInfo.permission_data;
        let PermissionArr = [];

        if(permissionList){
            PermissionArr = Object.values(permissionList);
        }
        let emailVerfiedFlag = this.state.userInfo.user_mail_address;
        if (this.state.isAuthenticated) {
            if (!emailVerfiedFlag){
                this.props.location.pathname = '/Account';
            } else{
                switch (this.props.location.pathname) {
                    case "/Forbidden":
                        break;
                    case "/Account":
                        break;
                    case "/SignIn":
                    case "/":
                        // ログイン直後もしくは初期画面は最初にread権限があるコンテナへ(一つもなければforbiddenへ)
                        if (PermissionArr.map(row => row.read).filter(value => value).length === 0) {
                            this.props.location.pathname = "/Forbidden";
                            alert(childProps.langText.Message.AuthCheckError);
                        } else {
                            let pathArr = [];
                            if(PermissionArr){
                                PermissionArr.forEach((row,index) => {
                                    if(row.read === true){
                                        pathArr.push(Object.keys(permissionList)[index]);
                                    }
                                });
                            }
                            this.props.location.pathname = "/" + pathArr[0];
                            // ログイン直後の権限セット
                            childProps.currentPermission = this.getCurrentPermission();
                        }
                        break;
                    case "/Category":
                    case "/ProperNoun":
                    case "/PhoneBook":
                    case "/AlarmSetting":
                    case "/NotificationSetting":
                        if (!this.state.userInfo.options.RecAceApp) {
                            // アプリ使用顧客では無い場合はforbidden(権限が存在しない場合{}も)
                            this.props.location.pathname = "/Forbidden";
                            alert(childProps.langText.Message.AuthCheckError);
                        }
                        break;
                    default:
                        // アクセスコンテナのread権限が無い場合はforbidden(権限が存在しない場合{}も)
                        if (!childProps.currentPermission.read) {
                            this.props.location.pathname = "/Forbidden";
                            alert(childProps.langText.Message.AuthCheckError);
                        }
                        break;
                }
            }
            appContent = <>
                <Row className="row-upper">
                    <Col xs={12} md={12} id="header-app" className="header-app Header">
                        <Header childProps={childProps}/>
                    </Col>
                </Row>
                <Row className="row-lower">
                    <Col xs={12} sm={12} id="routes-app" className="routes-app" style={{height: this.state.appHeight}}>
                        <Routes childProps={childProps}/>
                    </Col>
                </Row>
            </>;
        }

        return (
            !this.state.isAuthenticating && this.state.isThemeReady ?
            <div className = "App">
                {appContent}
                <div id="asc-block-ui" className="asc-block-ui asc-display-none z-index-1500">
                    <div className="asc-block-icon-box">
                        <ReactLoading className="asc-block-icon" type="spinningBubbles" color="#fff" />
                        <label className="asc-block-label">{childProps.langText.Body.Wait}</label>
                    </div>
                </div>
            </div>
            :
            <div className = "App">
                <div className="asc-block-ui">
                    <div className="asc-block-icon-box">
                        <ReactLoading className="asc-block-icon" type="spinningBubbles" color="#fff" />
                        <label className="asc-block-label">{childProps.langText.Body.Wait}</label>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(App);
